import { styled } from "styled-components";

export const LinkText = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.default[700]};
  font-weight: 600;
  line-height: 28px;
`;
